<!-- typeahead-location-input.component.html -->
<div class="w-full relative">
  <!-- Hidden honeypot fields to trick browser autofill -->
  <div aria-hidden="true" style="position: absolute; height: 0; width: 0; overflow: hidden; opacity: 0;">
    <input type="text" name="address1-fake" tabindex="-1" autocomplete="address-line1">
    <input type="text" name="city-fake" tabindex="-1" autocomplete="address-level2">
    <input type="text" name="country-fake" tabindex="-1" autocomplete="country-name">
  </div>

  <div class="relative">
    <!-- Input field with enhanced autofill prevention -->
    <input
      #inputElement
      [id]="label.toLowerCase() + '-' + randomId"
      [attr.name]="'location-' + type + '-' + randomId"
      type="text"
      [placeholder]="placeholder"
      class="input dark:!bg-secondary dark:!outline-secondary dark:!text-white pr-16"
      [class.border-red-500]="control.invalid && control.touched"
      [class.bg-gray-50]="control.disabled"
      [class.cursor-not-allowed]="control.disabled"
      [value]="searchTerm"
      [disabled]="control.disabled"
      (input)="onInput($event)"
      (focus)="onFocus()"
      (click)="onInputClick()"
      (blur)="onBlur()"
      autocomplete="chrome-off"
      [attr.autocomplete]="'new-' + randomId"
      [attr.data-form-type]="'other'"
      [attr.data-lpignore]="true"
    />

    <!-- Clear button -->
    <button
      *ngIf="control.value && !control.disabled"
      type="button"
      class="absolute right-8 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600 p-1"
      (mousedown)="$event.preventDefault()"
      (click)="clearSelection()"
      [attr.aria-label]="'Clear ' + label"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <line x1="18" y1="6" x2="6" y2="18"></line>
        <line x1="6" y1="6" x2="18" y2="18"></line>
      </svg>
    </button>

    <!-- Dropdown toggle button -->
    <button
      type="button"
      class="absolute right-2 top-1/2 transform -translate-y-1/2 p-1"
      (mousedown)="$event.preventDefault()"
      [class.text-gray-400]="!control.disabled"
      [class.hover:text-gray-600]="!control.disabled"
      [class.text-gray-300]="control.disabled"
      [class.cursor-not-allowed]="control.disabled"
      [disabled]="control.disabled"
      (click)="toggleDropdown()"
      [attr.aria-label]="'Toggle ' + label + ' dropdown'"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        [class.rotate-180]="isDropdownOpen"
        class="text-gray-400 hover:text-gray-600 transition-transform duration-200"
      >
        <polyline points="6 9 12 15 18 9"></polyline>
      </svg>
    </button>
  </div>

  <!-- Dropdown -->
  <!-- The mousedown shield keeps the input focused for ANY press inside the
       dropdown (options, scrollbar, loading/no-results areas), so blur only
       fires when focus genuinely leaves the component. -->
  <div
    *ngIf="isDropdownOpen && !control.disabled"
    class="absolute z-50 w-full mt-1 bg-white dark:bg-secondary-800 border border-gray-200 dark:border-secondary rounded-md shadow-lg max-h-60 overflow-y-auto"
    (mousedown)="$event.preventDefault()"
  >
    <!-- Loading state -->
    <div *ngIf="showLoading" class="p-3 text-sm text-gray-500 dark:text-gray-400 text-center">
      <div class="flex items-center justify-center">
        <svg class="animate-spin h-5 w-5 mr-2 text-gray-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
        Loading...
      </div>
    </div>

    <!-- No results message -->
    <div *ngIf="showNoResults" class="p-3 text-sm text-gray-500 dark:text-gray-400 text-center">
      <span *ngIf="searchTerm">No {{ label.toLowerCase() }} found for "{{ searchTerm }}".</span>
      <span *ngIf="!searchTerm">No {{ label.toLowerCase() }} available.</span>
    </div>

    <!-- Options list -->
    <ul *ngIf="!showLoading && getFilteredOptions().length > 0" class="py-1">
      <li
        *ngFor="let option of getFilteredOptions()"
        class="text-sm text-gray-700 dark:text-gray-300 px-3 py-2 hover:bg-gray-100 dark:hover:bg-secondary-700 cursor-pointer transition-colors duration-150"
        [class.bg-gray-100]="selectedOption?.id === option.id"
        [class.dark:bg-secondary-700]="selectedOption?.id === option.id"
        (click)="selectOption(option)"
      >
        <span [class.font-medium]="selectedOption?.id === option.id">
          {{ option.name }}
        </span>
      </li>
    </ul>
  </div>

  <!-- Validation message -->
  <div *ngIf="control.invalid && control.touched" class="text-red-500 text-xs mt-1">
    <span *ngIf="control.errors?.['required']">{{ label }} is required</span>
  </div>
</div>
